<template>
  <div class="about-top-panel">
    <img src="@/assets/images/IMG_1673_edited_cool_compressed_square.jpg" />
    <p>
      <span>Hello! 👋</span><br /><br />I'm a Software Engineer at Databricks and recent Mechatronics Engineering and IT graduate. I'm enthusiastic about programming, design, and all
      things in between.
      <br />
      <br />My dream is to create products and ideas which bring people
      together. I love challenging myself with new projects and always work hard
      to make the most of opportunities.
    </p>
  </div>
</template>

<script>
export default {
  name: "AboutTopPanel"
};
</script>

<style lang="scss" scoped>
@import "@/assets/_media_sizes.scss";
@import "@/assets/_colours.scss";
@import "@/assets/_font.scss";
@import "./style.scss";

.about-top-panel {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;

  img,
  p {
    margin: 10px 20px;
  }

  p {
    font-size: $font-S;
  }

  img {
    border-radius: 100%;
  }

  span {
    font-size: $font-L;
    font-weight: 600;
    font-family: "Roboto", sans-serif;
    margin-right: 10px;
    color: black;
  }
}

@media only screen and (min-width: $phone-S) {
  .about-top-panel {
    flex-direction: column;
    img {
      width: 80%;
      max-width: 300px;
    }

    p {
      width: 100%;
    }
  }
}

@media only screen and (min-width: $tablet-potrait) {
  .about-top-panel {
    margin-bottom: 75px;
    img,
    p {
      margin: 20px;
    }
  }
}

@media only screen and (min-width: $tablet-landscape) {
  .about-top-panel {
    flex-direction: row;

    img,
    p {
      margin: 20px;
    }

    img {
      max-width: 250px;
    }

    p {
      max-width: 500px;
    }
  }
}

@media only screen and (min-width: $desktop-xlg) {
  .about-top-panel {
        img {
      max-width: 300px;
    }
  }
}
</style>
